var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AdminJobCategoryList',{attrs:{"pk":'SFC-',"lockedFilters":{ ArticleNumberList: [_vm.$route.params.articleNumber] },"hideArticleFilter":""}})}
var staticRenderFns = []

export { render, staticRenderFns }